// import { replace } from 'react-router-redux';
import { replace } from 'connected-react-router';

import * as consts from './AppConsts';
import fullscreen from '../helpers/fullscreen';
import { getTourRequest } from '../helpers/requestUtils';
import * as notFoundActions from '../notFound/NotFoundActions';
import * as galleryActions from '../gallery/GalleryActions';
import * as listingsActions from '../listings/ListingsActions';
import * as mainActions from '../main/MainActions';

export const changeFullscreen = element => {
  return (dispatch, getState) => {
    fullscreen(element);
    dispatch({
      type: consts.CHANGE_FULLSCREEN,
      payload: !getState().app.fullscreenEnabled
    });
  };
};

export const savePosition = element => {
  return {
    type: consts.SAVE_POSITION,
    payload: element
  };
};

export const clearPosition = () => {
  return {
    type: consts.CLEAR_POSITION
  };
};

export const setUrlParams = (tourId, tourType) => {
  return dispatch => {
    dispatch({
      type: consts.SET_URL_PARAMS,
      payload: {
        tourId,
        tourType
      }
    });
  };
};

export const getTour = (tourId, tourType) => {
  return dispatch => {
    dispatch({
      type: consts.GET_TOUR_PENDING
    });

    return getTourRequest(tourId, tourType).then(
      response => {
        if (isOrderDisabled(!!+response.data.disabled)) {
          dispatch(notFoundActions.redirectToNotFound());
          dispatch({
            type: consts.GET_TOUR_REJECTED,
            payload: {
              getTourError: 'Order is disabled'
            }
          });
          return;
        }

        if (isOrderCanceled(!!+response.data.canceled)) {
          dispatch({
            type: consts.GET_TOUR_REJECTED,
            payload: {
              getTourError: 'Order is canceled'
            }
          });
          dispatch(notFoundActions.redirectToCanceled());
          return;
        }


        const isDrafted = response.data.is_draft;
        const isLogined = response.data.is_logined;
        if (!isOrderProduced(isDrafted, isLogined)) {
          dispatch({
            type: consts.GET_TOUR_REJECTED,
            payload: {
              getTourError: 'Order is not produced'
            }
          });
          dispatch(notFoundActions.redirectToNotProduced());
          return;
        }
        dispatch({
          type: consts.GET_TOUR_FULFILLED,
          payload: response.data
        });
        dispatch(galleryActions.getGallery());
        dispatch(listingsActions.getListings());
      },
      error => {
        console.log(error);
        dispatch({
          type: consts.GET_TOUR_REJECTED,
          payload: {
            getTourError: error
          }
        });
        dispatch(notFoundActions.redirectToNotFound());
      }
    );
  };
};

export const postMessageEvent = (values) => {
  return {
      type: consts.POST_MESSAGE_EVENT,
      payload: values
  }
}

export const setContentBlur = blurValue => {
  return {
    type: consts.SET_CONTENT_BLUR,
    payload: blurValue
  };
};

/**
 * check if tour is in draft and user is not loggined in
 *
 * @param {bool} isDrafted order is in draft
 * @param {bool} isLogined user is loggined in
 * @returns {bool} order was produced
 */
const isOrderProduced = (isDrafted, isLogined) => {
  if (isDrafted && !isLogined) {
    return false;
  }
  return true;
};
/**
 * check if order is disabled
 *
 * @param {bool} disabled
 * @returns {bool} order disabled
 */
const isOrderDisabled = disabled => {
  if (disabled) {
    return true;
  }
  return false;
};

/**
 * check if order is canceled
 *
 * @param {bool} canceled
 * @returns {bool} order canceled
 */
const isOrderCanceled = canceled => {
  if (canceled) {
    return true;
  }
  return false;
};

export const redirectToHome = (noHeroPhoto) => {
  return (dispatch, getState) => {
    const defaultPage = getState().menu.buttonsParams.defaultButton;
    const tourId = getState().app.tourId;
    const tourType = getState().app.tourType;
    const { matterport, video, gallery } = getState();
    let page = '';
    switch (defaultPage) {
      case 'HeroPhoto':
        dispatch(mainActions.setTimeoutStartComponent(false, noHeroPhoto));
        break;
      case 'Photos':
        page = 'gallery';
        !noHeroPhoto && dispatch(mainActions.setTimeoutStartComponent());
        break;
      case 'FloorPlan':
        page = 'floorplan';
        !noHeroPhoto && dispatch(mainActions.setTimeoutStartComponent());
        break;
      case 'Matterport':
        if (matterport.matterport.length) {
          let order =
            matterport.matterportType === 'id'
              ? parseInt(matterport.matterport[0].sort_order) + 1
              : 1;
          page = `matterport/${order}`;
          !noHeroPhoto && dispatch(mainActions.setTimeoutStartComponent());
        }
        break;
      case 'Video':
        page = 'walkthru';
        !noHeroPhoto && dispatch(mainActions.setTimeoutStartComponent());
        break;
      case 'Presented':
        page = 'presented';
        break;
      case 'CustomVideo':
        if (video.videos.length) {
          let order =
            video.videoType === 'id' ? parseInt(video.videos[0].sort_order) : 1;
          page = `video/${order}`;
          !noHeroPhoto && dispatch(mainActions.setTimeoutStartComponent());
        }
        break;
    }

    if (!gallery.galleryExists && (!page || page == 'gallery')) {
      if (video.videos.length) {
        let order = 1;
        if (video.videoType === 'id') {
          order = video.videos[0].sort_order;
        }
        page = `video/${order}`;
        !noHeroPhoto && dispatch(mainActions.setTimeoutStartComponent());
      }

      if (matterport.matterport.length) {
        let order = 1;
        if (matterport.matterportType === 'id') {
          order = parseInt(matterport.matterport[0].sort_order) + 1;
        }
        page = `matterport/${order}`;
        !noHeroPhoto && dispatch(mainActions.setTimeoutStartComponent());
      }
    }

    if (page) {
       setTimeout(
            () => dispatch(replace(`/${tourId}/${tourType.charAt(0)}/${page}`)),
            !noHeroPhoto ? 3000 : 0
          )
    } else {
      dispatch(replace(`/${tourId}/${tourType.charAt(0)}`));
    }
  };
};
